import { defineMessages } from "react-intl";

export default defineMessages({
  managementCosts: {
    id: "subscriptionAdvantage.managementCosts",
    defaultMessage: "<bold>0% management fees</bold> on all your services",
  },
  guaranteeSatisfaction: {
    id: "subscriptionAdvantage.guaranteeSatisfaction",
    defaultMessage: "<bold>Guarantee: Satisfied</bold> or resale",
  },
  cancelForFree: {
    id: "subscriptionAdvantage.cancelForFree",
    defaultMessage: "Something came up? <bold>Cancel for free</bold>",
  },
  insuranceCovered: {
    id: "subscriptionAdvantage.insuranceCovered",
    defaultMessage: "Did something go wrong? Don't worry, our <bold>AXA insurance</bold> has you covered",
  },
});
